import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarIcon, UserIcon, ArrowRightIcon } from '@heroicons/react/24/outline';

const BlogCard = ({ post }) => {
  const { id, title, excerpt, image, author, date, category, slug } = post;
  
  // Format date
  const formattedDate = new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
      <Link to={`/blog/${slug}`} className="block">
        <img 
          src={image} 
          alt={title} 
          className="w-full h-56 object-cover transition-transform duration-300 hover:scale-105"
        />
      </Link>
      
      <div className="p-6">
        <div className="flex justify-between items-center mb-3">
          <span className="bg-primary-light text-primary text-sm font-medium px-3 py-1 rounded-full">
            {category}
          </span>
          <div className="flex items-center text-gray-500 text-sm">
            <CalendarIcon className="h-4 w-4 mr-1" />
            {formattedDate}
          </div>
        </div>
        
        <Link to={`/blog/${slug}`} className="block">
          <h3 className="text-xl font-bold mb-3 text-gray-800 hover:text-primary transition-colors duration-300">
            {title}
          </h3>
        </Link>
        
        <p className="text-gray-600 mb-4 line-clamp-3">
          {excerpt}
        </p>
        
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <img 
              src={author.avatar} 
              alt={author.name} 
              className="w-8 h-8 rounded-full mr-2 object-cover"
            />
            <span className="text-sm text-gray-700 font-medium">{author.name}</span>
          </div>
          
          <Link 
            to={`/blog/${slug}`} 
            className="flex items-center text-primary font-medium hover:text-primary-dark transition-colors"
          >
            Read More
            <ArrowRightIcon className="h-4 w-4 ml-1" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
